import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

interface Image2Props {
    cls?: string;
    src: ImageSrcSet;
    width?: number;
    height?: number;
}

export interface ImageSrcSet {
    src: string;
    src2x: string;
    src3x: string;
}

export class Image2 extends React.Component<Image2Props> {
    render() {
        const { cls, src, width, height } = this.props;

        return (
            <img
                className={classNames(cls, Bem.cls('image2'))}
                src={src.src}
                width={width}
                height={height}
                srcSet={this.getSrcsetValue(src)}
            />
        );
    }

    private getSrcsetValue(image: ImageSrcSet): string {
        return `${image.src2x} 2x, ${image.src3x} 3x`;
    }
}
